import { useEffect, useMemo, useRef, useState } from "react";
import { Layout, Breadcrumbs, ProgressLoader, Card, Text, Heading } from "@netapp/bxp-design-system-react";
import { useTranslation } from 'react-i18next';
import { connectorsettings as i18nNamespace } from "../../../../i18n/namespace";
import { Link } from "react-router-dom";
import styles from "./ValidateAgent.module.scss";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import ValidateAgentTable from './ValidateAgentTable';
import classNames from "classnames";

export default () => {
    const { t } = useTranslation(i18nNamespace);
    const dispatch = useDispatch();
    let { agentId } = useParams();
    const agents = useSelector(state => state.tenancy.agents);
    const agent = _.find(agents, (agent) => agent.id === agentId);
    const validationCompleted = useSelector(state => state.connectorSettings?.validateAgent?.validationCompleted);
    const validationSucceeded = useSelector(state => state.connectorSettings?.validateAgent?.validationSucceeded);
    const agentValidations = useSelector(state => {
        const validations = _.get(state, 'connectorSettings.validateAgent.config.services[0].validations');
        return validations?.flatMap(v => v?.checks ?? []) ?? [];
    });
    const intervalIdRef = useRef(null);

    useEffect(() => {
        if (agentId) {
            dispatch({
                type: "CONNECTOR-SETTINGS:GET-AGENT-VALIDATION-STATUS",
                payload: {
                    agentId
                }
            });
        }
    }, [agentId, dispatch])

    useEffect(() => {
        if (!intervalIdRef.current && validationCompleted === false) {
            intervalIdRef.current = setInterval(() => {
                dispatch({
                    type: "CONNECTOR-SETTINGS:GET-AGENT-VALIDATION-STATUS",
                    payload: { agentId }
                });
            }, 5000);
        }

        if (validationCompleted === true && intervalIdRef.current) {
            clearInterval(intervalIdRef.current);
            intervalIdRef.current = null;
        }

        // Cleanup on unmount
        return () => {
            if (intervalIdRef.current) {
                clearInterval(intervalIdRef.current);
                intervalIdRef.current = null;
            }
        };
    }, [validationCompleted, agentId, dispatch]);

    useEffect(() => {
        if (validationSucceeded) {
            dispatch({
                type: "NOTIFICATIONS:SUCCESS",
                payload: {
                    message: t("validation_completed"),
                    showGlobal: true
                }
            })
        }
    }, [validationSucceeded, dispatch]);

    const percentValue = useMemo(() => {
        if (!agentValidations?.length) return 0;
        const successCount = agentValidations?.filter(c => (c.status === "SUCCESS" || c.status === "FAILED")).length;
        return Math.round((successCount / agentValidations?.length) * 100);
    }, [agentValidations]);

    return <Layout.Page>
        <Layout.Content>
            <Layout.BreadcrumbsContainer>
                <Breadcrumbs className={styles["breadcrumbs"]}>
                    <Link to="/agents-mgmt">{t("overview")}</Link>
                    <div>{t("validation_agent_capital")}</div>
                </Breadcrumbs>
            </Layout.BreadcrumbsContainer>
            <Layout.Container>
                <Heading className={styles["display-inline"]} level="20" bold>{agent?.name}</Heading>
                <Heading className={classNames(styles['display-inline'], styles['margin-left'])} level="20">{t("validation_agent")}</Heading>
                <br /><br />
                <Card style={{ padding: 40 }}>
                    <div className={styles["container"]}>
                        <Heading className={styles["text-wrap"]} level="16" bold>{t("validate_progress")}</Heading>
                        <ProgressLoader className={styles["progress-bar"]} small percent={percentValue} />
                        <Text className={styles["margin-left"]}>{percentValue}%</Text>
                    </div>
                </Card>
                <br />
                <ValidateAgentTable agentId={agentId} agentName={agent?.name} />
            </Layout.Container>
        </Layout.Content>
    </Layout.Page>
};